<template>
    <div class="spinner field has-addons">
        <p class="control">
            <a class="button" v-on:click="onDecrementClicked">-</a>
        </p>
        <p class="control">
            <input class="input" type="text" :value="this.value" v-on:input="update">
        </p>
        <p class="control">
            <a class="button" v-on:click="onIncrementClicked">+</a>
        </p>
    </div>
</template>

<script>
    export default {
        name: 'Spinner',
        props: {
            value: {
                default: 1,
                type: Number
            }
        },
        data() {
            return {}
        },
        methods: {
            onDecrementClicked() {
                this.$emit('input', this.value - 1);
            },

            onIncrementClicked() {
                this.$emit('input', this.value + 1);
            },

            update(event) {
                let n = parseInt(event.target.value);
                if(n)
                    this.$emit('input', n);
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>